/*
 * Copyright (c) 2023 Supre  <https://www.supre.com.co>
 *
 * All Rights Reserved
 * This product is protected by copyright and distributed under
 * licenses restricting copying, distribution and decompilation.
 */

import GeneralData from "../GeneralData";

/**
Created by  José Nicolás Pereira 11/9/23
@author : José Nicolás Pereira <jpereira@supre.com.co>
@date : 11/9/23
@project : omnia-site
*/

export const DataPrivacy = () => {
  return (
    <div>
      <p className="paragraphs">
        <b>Suprecredito S.A.S.</b>, identificada con NIT. 901347233 - 8 (de
        ahora en adelante “Suprecredito”), en cumplimiento de lo previsto en la
        Ley 1581 de 2012, Ley 1266 de 2008, y los Decretos que los reglamentan,
        adopta como responsable del tratamiento la siguiente política de
        privacidad de datos (en adelante “La Política”), que será aplicable a la
        plataforma
        <a href="https://supre.com.co/">
          {" "}
          https://supre.com.co/
        </a>.
      </p>
      <p className="paragraphs">
        Antes de realizar cualquier acción en o a través de la plataforma de{" "}
        Suprecredito, el Usuario debe leer cuidadosamente la presente
        Política de Privacidad y Protección de Datos y aceptar la Autorización
        para el tratamiento, previo a aceptar la misma y suministrar sus Datos
        Personales. Si no estás de acuerdo con la presente Política o el
        tratamiento de sus datos personales, el Usuario debe abstenerte de dar
        la Autorización.
      </p>
      <p className="paragraphs">
        Antes de realizar cualquier acción en o a través de la plataforma de{" "}
        Suprecredito garantiza los derechos a la intimidad personal y
        familiar y al buen nombre de los usuarios durante el tratamiento de los
        datos personales, y, en consecuencia, todas sus actuaciones se regirán
        por los principios de legalidad, finalidad, libertad, veracidad o
        calidad, transparencia, acceso y circulación restringida, seguridad y
        confidencialidad, consagrados en el artículo 4 de la Ley Estatutaria
        1581 de 2012 y demás normas que reglamenten, o modifiquen.
      </p>
      <ol >
        <li className="paragraphs">
          <h2 className="o-heading-4">Definiciones</h2>
          <p className="paragraphs">
            Para efecto e interpretación de esta Política, de las obligaciones
            de Suprecredito, así como de las obligaciones y derechos de los
            Usuarios, al amparo de las normas aplicables y de la voluntad
            contractual de las partes, se entiende por:
          </p>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Suprecredito: sociedad debidamente constituida bajo la
                legislación colombiana.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Autorización: consentimiento previo, expreso e informado del
                Usuario de la información para llevar a cabo el tratamiento.
                Esta puede ser escrita, verbal o mediante conductas inequívocas
                que permitan concluir de forma razonable que el Usuario otorgó
                autorización.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Dato Personal Privado: es el dato que por su naturaleza íntima o
                reservada sólo es relevante para la persona Usuario de la
                información.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Dato Personal Público: es el dato calificado como tal según los
                mandatos de la ley o de la Constitución Política y todos
                aquellos que no sean semiprivados o privados. Son públicos,
                entre otros, los datos contenidos en documentos públicos,
                registros públicos, gacetas y boletines oficiales y sentencias
                judiciales debidamente ejecutoriadas que no estén sometidos a
                reserva, los relativos al estado civil de las personas, a su
                profesión u oficio y a su calidad de comerciante o de servidor
                público.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Dato Personal Semiprivado: es semiprivado el dato que no tiene
                naturaleza íntima, reservada, ni pública y cuyo conocimiento o
                divulgación puede interesar no sólo a su Usuario sino a cierto
                sector o grupo de personas o a la sociedad en general.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Dato Personal Sensible: información que afecta la intimidad de
                la persona o cuyo uso indebido puede generar su discriminación.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Dato(s) Personal(es): cualquier información vinculada o que
                pueda asociarse a una o varias personas naturales determinadas o
                determinables. El Dato Personal se clasifica en sensible,
                público, privado y semiprivado.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Encargado: persona que realiza el tratamiento de datos por
                cuenta del Responsable del tratamiento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Hábeas Data: derecho del Usuario de la información a conocer,
                actualizar o rectificar Datos Personales.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Responsable: persona natural o jurídica, pública o privada, que
                por sí misma o en asocio con otros, decida sobre la base de
                datos y/o el tratamiento de los Datos Personales.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Usuario: es la persona natural que desea interactuar con la
                plataforma Suprecreditodigital.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
              tratamiento: operación o conjunto de operaciones sobre los Datos
                Personales.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">
            Principios para el tratamiento de Datos Personales
          </h2>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de libertad: el tratamiento sólo puede ejercerse con
                el consentimiento, previo, expreso e informado del Usuario. Los
                datos personales no podrán ser obtenidos o divulgados sin previa
                autorización, o en ausencia de mandato legal o judicial que
                releve el consentimiento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de limitación de la recolección: sólo deben
                recolectarse los Datos Personales que sean estrictamente
                necesarios para el cumplimiento de las finalidades del
                tratamiento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de finalidad: el tratamiento debe obedecer a una
                finalidad legítima de acuerdo con la Constitución y la Ley, la
                cual debe ser informada al Usuario.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de temporalidad: los Datos Personales se conservarán
                únicamente por el tiempo razonable y necesario para cumplir la
                finalidad del tratamiento y las exigencias legales o
                instrucciones de las autoridades de vigilancia y control u otras
                autoridades competentes.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de veracidad o calidad: la información sujeta a
                tratamiento debe ser veraz, completa, exacta, actualizada,
                comprobable y comprensible. Se prohíbe el tratamiento de datos
                parciales, incompletos, fraccionados o que induzcan a error.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de legalidad: el tratamiento a que se refiere la Ley
                1581 de 2012 es una actividad reglada que debe sujetarse a lo
                establecido en ella y en las demás disposiciones que la
                desarrollen.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de transparencia: en el tratamiento debe garantizarse
                el derecho del Usuario a obtener del Responsable del tratamiento
                o del Encargado del tratamiento, en cualquier momento y sin
                restricciones, información acerca de la existencia de datos que
                le concierne.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de acceso y circulación restringida: el tratamiento
                sólo podrá hacerse por personas autorizadas por el Usuario.
                Adicionalmente, los datos personales, salvo la información
                pública, no podrán estar disponibles en Internet u otros medios
                de divulgación o comunicación masiva, salvo que el acceso sea
                técnicamente controlable para brindar un conocimiento
                restringido sólo a los titulares o terceros autorizados.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de seguridad: la información sujeta a tratamiento por
                el Responsable del tratamiento o Encargado del tratamiento, se
                deberá manejar con las medidas técnicas, humanas y
                administrativas que sean necesarias para otorgar seguridad a los
                registros evitando su adulteración, pérdida, consulta, uso o
                acceso no autorizado o fraudulento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Principio de confidencialidad todas las personas que intervengan
                en el tratamiento de Datos Personales que no tengan la
                naturaleza de públicos están obligadas a garantizar la reserva
                de la información, inclusive después de finalizada su relación
                con alguna de las labores que comprende el tratamiento, pudiendo
                sólo realizar suministro o comunicación de datos personales
                cuando ello corresponda al desarrollo de las actividades
                autorizadas en Ley 1581 de 2012 y en los términos de esta.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4"> Alcance </h2>
          <p className="paragraphs">
            La presente Política deberá ser aplicada por todos los funcionarios
            de <b>Suprecredito</b>, por lo tanto, se adelantarán las campañas
            pedagógicas y de capacitación, para que las áreas que participan o
            realizan tratamiento de Datos Personales conozcan la Política y las
            leyes aplicables para asegurar su cumplimiento.
          </p>
          <p className="paragraphs">
            Así mismo, esta Política deberá ser conocida y cumplida por los
            Terceros que traten o tengan conocimiento de los Datos Personales.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">
            Finalidad y autorizaciones del tratamiento de Datos Personales
          </h2>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Sin perjuicio de las excepciones previstas en la Ley, para el
                tratamiento de Datos Personales se requiere la autorización
                previa e informada del Titular, la cual deberá ser obtenida por
                cualquier medio que pueda ser objeto de consulta posterior.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                La autorización del titular no será necesaria cuando se trate
                de: Información requerida por una entidad pública o
                administrativa en ejercicio de sus funciones legales o por orden
                judicial; Datos de naturaleza pública; Casos de urgencia médica
                o sanitaria; tratamiento de información autorizado por la ley
                para fines históricos, estadísticos o científicos; Datos
                relacionados con el Registro Civil de las Personas.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Las finalidades del tratamiento de Datos Personales
                suministrados en tu calidad de Titular son:
              </p>
              <ol className="c-lista-2">
                <li className="paragraphs">
                  <p className="paragraphs">
                    Para los fines propios de los contratos que se hayan
                    celebrado o a celebrar entre Suprecredito y sus
                    usuarios y clientes, al igual que frente a los servicios que
                    ofrece y presta Suprecredito a través de su página
                    y/o sus aplicaciones y aquellas actividades derivadas de su
                    objeto social.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Dar a conocer los servicios ofrecidos por{" "}
                    Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Desarrollar los procesos que se requieran para la adecuada
                    prestación de los productos y/o servicios contratados por
                    los usuarios y/o clientes de Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Evaluar, mantener, mejorar y profundizar la relación
                    contractual, en sus distintas fases, incluyendo los actos
                    relacionados con la etapa precontractual como el
                    ofrecimiento de nuevos productos y/o servicios y/o
                    información sobre eventos, novedades, promociones,
                    publicidad y programas de fidelidad, mediante el uso de
                    correo electrónico, correo postal, teléfono fijo, celular,
                    fax, SMS, MSM, redes sociales o medios similares.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Actualizar los datos suministrados con la información que se
                    encuentre disponible en los Operadores de Información o
                    cualquier otra persona, entidad u organización que maneje o
                    administre bases de datos con los fines legalmente definidos
                    para este tipo de entidades.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Analizar, desarrollar e implementar herramientas de
                    prevención de fraudes y/o suplantaciones y/o riesgos del
                    sistema informático de Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Compartir los datos relativos a la información de los
                    clientes, lo cual incluye el uso y la actualización de los
                    datos de contacto, con firmas especializadas en labores de
                    cobranzas para que adelanten la gestión de cobro recaudo de
                    las obligaciones contraídas, y demás servicios que se
                    consideren necesarios o complementarios; así como, el manejo
                    de la cartera vencida, utilizando para ello tanto los
                    mecanismos judiciales como también las vías extraprocesales
                    permitidas por el ordenamiento jurídico.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    La evaluación de la solvencia, idoneidad, riesgos del
                    deudor, su comportamiento de pago, el cobro de las cuotas,
                    tasas y cargos correspondientes, tanto de manera prejudicial
                    como judicial, según corresponda.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Remitir las respuestas de las consultas y derechos de
                    petición a los peticionarios.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Adelantar los trámites y servicios que sean solicitados a{" "}
                  Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Realizar campañas y actividades de divulgación y ofertas de
                    los servicios y/o productos de la Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Actualizar Bases de Datos, incluyendo los casos en que se
                    requiera transmitir o transferir a un tercero, la
                    información para la validación, depuración, enriquecimiento
                    y homogenización de datos, previo cumplimiento de las
                    exigencias legales.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Elaborar estudios, estadísticas, encuestas, análisis de
                    tendencias, relacionados con los servicios que presta{" "}
                    Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Gestionar la información necesaria para el cumplimiento de
                    las obligaciones tributarias, contractuales, comerciales y
                    de registros comerciales, corporativos y contables.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Transmitir la información a encargados nacionales o
                    internacionales con los que se tenga una relación operativa
                    que provean los servicios necesarios para la debida
                    operación de Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Realizar todas las actividades necesarias para el
                    cumplimiento de las diferentes etapas contractuales en las
                    relaciones con los clientes actuales y potenciales.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Mantener un archivo digital que permita contar con la
                    información correspondiente a cada contrato.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Consultar, solicitar y divulgar información que corresponda
                    y guarde relación con movimientos, facturación, compras,
                    estadísticas, preferencias, movimientos de inventario y
                    demás transacciones comerciales del Titular y estén en
                    custodia y/o administración de información de los
                    proveedores de Suprecredito. Esta facultad
                    estará vigente mientras subsista alguna relación comercial y
                    será de único manejo para estadísticas y estudios por parte
                    de Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Con fines estadísticos, financieros y/o comerciales, así
                    como para evaluar los riesgos derivados de una posible
                    relación contractual, consultar, informar, reportar,
                    procesar y/o divulgar, a las entidades de consulta de bases
                    de datos o Centrales de Información y Riesgo, todo lo
                    referente al comportamiento (presente, pasado y futuro) del
                    Titular como Usuario, el endeudamiento, y en especial el
                    nacimiento, modificación y extinción de obligaciones
                    contraídas por el Titular o que llegaren a contraer a través
                    de Suprecredito.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Consultar cualquier información sobre las relaciones
                    comerciales que reposen en las bases de datos de entidades
                    públicas y/o privadas, bien fuere en Colombia o en el
                    exterior, así como la de reportar, procesar y distribuir
                    dicha información.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Compartir con los vinculados o aliados comerciales Datos
                    Personales para fines de presentar al Titular ofertas sobre
                    sus servicios y productos, pudiendo revocar la autorización
                    para esta finalidad contactando al Responsable del
                    tratamiento de los Datos.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Permitir a terceras personas acceder a la información
                    relativa al comportamiento, comercial y financiero presente,
                    pasado y futuro, del Titular con los efectos comerciales y
                    financieros a que haya lugar
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Consultar y almacenar referencias personales, familiares o
                    comerciales diligenciadas en la Solicitud de Crédito, para
                    profundizar el conocimiento que éstas tienen del Titular
                    como Solicitante y como un medio de contacto para ubicar al
                    Titular.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Recolectar, almacenar y usar Datos Biométricos (Datos
                    Sensibles) como mecanismo de identificación y autenticación.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Recolectar, usar, comprobar, compartir almacenar, modificar,
                    procesar, monitorear, ordenar, comparar, analizar, consultar
                    Datos Personales y Financieros para la realizar los
                    siguientes procesos: (i) verificación de identidad, (ii)
                    prospección comercial y perfilamiento, (iii) administración
                    y evaluación de riesgo, (iii) cumplimiento de obligaciones
                    contractuales y (iv) demás actividades relacionadas con la
                    prestación de los servicios por parte de Suprecredito.
                    .
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Consultar, actualizar o reportar el nacimiento, ejecución y
                    extinción de las obligaciones del Titular en la base de
                    datos administrada por los operadores de información o
                    bureaus de crédito.
                  </p>
                </li>
              </ol>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Las finalidades de tratamiento previstas de los datos de
                candidatos, empleados, proveedores y accionistas.
              </p>
              <ol className="c-lista-2">
                <li className="paragraphs">
                  <p className="paragraphs">
                    Para todos los fines relacionados con el objeto de los
                    procesos de selección, contractuales o relacionados con
                    éstos.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Realizar todos los trámites internos y el cumplimiento de
                    obligaciones contables, tributarias y de ley.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Gestionar el presupuesto de la Compañía.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Realizar todas las actividades necesarias para el
                    cumplimiento de las diferentes etapas contractuales en las
                    relaciones con proveedores y contratistas.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Expedir las certificaciones contractuales solicitadas por
                    los contratistas de la Compañía.
                  </p>
                </li>
                <li className="paragraphs">
                  <p className="paragraphs">
                    Mantener un archivo digital que permita contar con la
                    información correspondiente a cada contrato.
                  </p>
                </li>
              </ol>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Realizar la verificación, validación y autenticación de la identidad del
                Titular a través de mecanismos de validación por una sola vez (OTP) u otros
                medios tecnológicos en canales digitales, con el fin de prevenir el fraude,
                la suplantación de identidad y gestionar el acceso a los servicios ofrecidos
                por Suprecredito. Para estos efectos, Suprecredito podrá recolectar,
                almacenar, usar y procesar los Datos Personales suministrados, incluyendo
                datos de contacto y, cuando resulte necesario, datos sensibles como datos
                biométricos, previa autorización expresa del Titular. El Titular podrá
                conocer, actualizar, rectificar y revocar la autorización para el tratamiento
                de sus datos conforme a la normativa vigente.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4"> Derechos del Usuario</h2>
          <p className="paragraphs">
            De conformidad con lo dispuesto en el artículo 8 de la Ley 1581 de
            2012, el Usuario de los Datos Personales tiene los siguientes
            derechos:
          </p>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Conocer, actualizar y rectificar sus Datos Personales frente a
                los Responsables o Encargados del tratamiento. Este derecho se
                podrá́ ejercer, entre otros, frente a datos parciales, inexactos,
                incompletos, fraccionados, que induzcan a error o aquellos cuyo
                tratamiento esté expresamente prohibido, o no haya sido
                autorizado, mediante la presentación de la respectiva consulta o
                reclamo de acuerdo con lo dispuesto en la presente Política.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Solicitar prueba de la Autorización otorgada al Responsable,
                salvo cuando expresamente se ​exceptúa como requisito para el
                tratamiento, de conformidad con lo previsto en el artículo 10 de
                la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Ser informado por el Responsable del tratamiento, previa
                solicitud, respecto del uso que le ha dado a sus Datos
                Personales.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Presentar ante la Superintendencia de Industria y Comercio
                quejas por infracciones a lo dispuesto en la legislación
                vigente, previo agotamiento del trámite de consulta o reclamo
                ante Suprecredito previsto como requisito de procedibilidad en
                el artículo 16 de la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Revocar la Autorización y/o solicitar la supresión del dato
                cuando en el tratamiento no se respeten los principios, derechos
                y garantías constitucionales y legales. La revocatoria y/o
                supresión, procederá cuando la Superintendencia de Industria y
                Comercio haya determinado que en el tratamiento el Responsable
                ha incurrido en conductas contrarias a la ley o la Constitución.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Acceder en forma gratuita a sus Datos Personales que hayan sido
                objeto de tratamiento.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4"> Responsable</h2>
          <p className="paragraphs">
            Suprecredito S.A.S Identificada con Nit N° 901347233-8, por
            intermedio de su Representante Legal designará al Oficial de
            Protección de datos, quien será el responsable del tratamiento de
            datos.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4"> Deberes del Responsable </h2>
          <p className="paragraphs">
            El Responsable del tratamiento deberá cumplir los siguientes
            deberes, conforme al artículo 17 de la Ley 1581 de 2012:
          </p>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Garantizar al Usuario, en todo tiempo, el pleno y efectivo
                ejercicio del derecho de hábeas data.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Solicitar y conservar, en las condiciones previstas en la Ley
                1581 de 2012, copia de la respectiva autorización otorgada por
                el Usuario.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Informar debidamente al Usuario sobre la finalidad de la
                recolección y los derechos que le asisten por virtud de la
                autorización otorgada.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Conservar la información bajo las condiciones de seguridad
                necesarias para impedir su adulteración, pérdida, consulta, uso
                o acceso no autorizado o fraudulento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Garantizar que la información que se suministre al Encargado del
                tratamiento sea veraz, completa, exacta, actualizada,
                comprobable y comprensible.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Actualizar la información, comunicando de forma oportuna al
                Encargado del tratamiento, todas las novedades respecto de los
                datos que previamente le haya suministrado y adoptar las demás
                medidas necesarias para que la información suministrada a este
                se mantenga actualizada.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Rectificar la información cuando sea incorrecta y comunicar lo
                pertinente al Encargado del tratamiento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Suministrar al Encargado del tratamiento, según el caso,
                únicamente datos cuyo tratamiento esté previamente autorizado de
                conformidad con lo previsto en la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Exigir al Encargado del tratamiento en todo momento, el respeto
                a las condiciones de seguridad y privacidad de la información
                del Usuario.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Tramitar las consultas y reclamos formulados en los términos
                señalados en la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Adoptar un manual interno de políticas y procedimientos para
                garantizar el adecuado cumplimiento de la Ley 1581 de 2012 y en
                especial, para la atención de consultas y reclamos.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Informar al Encargado del tratamiento cuando determinada
                información se encuentra en discusión por parte del Usuario, una
                vez se haya presentado la reclamación y no haya finalizado el
                trámite respectivo.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Informar a solicitud del Usuario sobre el uso dado a sus Datos
                Personales.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Informar a la autoridad de protección de datos cuando se
                presenten violaciones a los códigos de seguridad y existan
                riesgos en la administración de la información de los Usuarios.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Cumplir las instrucciones y requerimientos que imparta la
                Superintendencia de Industria y Comercio.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4"> Deberes del Encargado</h2>
          <p className="paragraphs">
            Conforme al artículo 18 de la Ley 1581 de 2012, en el evento en que
            concurran las calidades de Responsable y Encargado del tratamiento,
            será exigible el cumplimiento de los deberes previstos para cada
            uno, por lo cual se deben tener en cuenta los siguientes deberes en
            calidad de Encargado del tratamiento.
          </p>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Garantizar al Usuario, en todo tiempo, el pleno y efectivo
                ejercicio del derecho de Hábeas Data. 
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Conservar la información bajo las condiciones de seguridad
                necesarias para impedir su adulteración, pérdida, consulta, uso
                o acceso no autorizado o fraudulento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Realizar oportunamente la actualización, rectificación o
                supresión de los datos en los términos de la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Actualizar la información reportada por los Responsables del
                tratamiento dentro de los cinco (5) días hábiles contados a
                partir de su recibo.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Tramitar las consultas y los reclamos formulados por los
                Usuarios en los términos señalados en la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Adoptar un manual interno de políticas y procedimientos para
                garantizar el adecuado cumplimiento de la Ley 1581 de 2012 y, en
                especial, para la atención de consultas y reclamos por parte de
                los ​titulares​.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Registrar en la base de datos la leyenda "reclamo en trámite" en
                la forma en que se regula en la Ley 1581 de 2012.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Insertar en la base de datos la leyenda "información en
                discusión judicial" una vez notificado por parte de la autoridad
                competente sobre procesos judiciales relacionados con la calidad
                del Dato Personal.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Abstenerse de circular información que esté siendo controvertida
                por el Usuario y cuyo bloqueo haya sido ordenado por la
                Superintendencia de Industria y Comercio.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Permitir el acceso a la información únicamente a las personas
                que pueden tener acceso a ella.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Informar a la Superintendencia de Industria y Comercio cuando se
                presenten violaciones a los códigos de seguridad y existan
                riesgos en la administración de la información de los Usuarios.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Cumplir las instrucciones y requerimientos que imparta la
                Superintendencia de Industria y Comercio.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">Autorización</h2>
          <p className="paragraphs">
            Para poder usar la plataforma Suprecredito, se le solicitará
            al Usuario de manera previa a la recolección de los datos, la
            Autorización para el tratamiento de estos y se le informarán los
            Datos Personales que serán recolectados, así como las finalidades
            específicas del tratamiento para las cuales se obtiene el
            consentimiento.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">Seguridad de la información</h2>
          <p className="paragraphs">
            Suprecredito utiliza mecanismos físicos y electrónicos,
            además de procedimientos y prácticas, que buscan la seguridad de la
            información, prevenir su adulteración, pérdida, consulta, uso o
            acceso no autorizado o fraudulento. Lo anterior, incluye medidas de
            seguridad físicas e informáticas, como esquemas de encriptación o
            firewalls, para proteger la información que el Usuario suministra.
          </p>
          <p className="paragraphs">
            Suprecredito realiza pruebas de seguridad con frecuencia con
            el fin de asegurar un ambiente lo más seguro posible para los
            Usuarios de los Datos Personales.
          </p>
          <p className="paragraphs">
            En caso de cualquier anomalía o circunstancia que afecte o pudiera
            afectar la seguridad de las Bases de Datos o información contenida
            en las mismas, o la confidencialidad o la reserva, el Usuario deberá
            ​comunicar a​ Suprecredito, quien adoptará medidas oportunas frente
            al incidente reportado, sin perjuicio de las obligaciones de
            Suprecredito de reportar a la autoridad competente, de conformidad
            con las normas jurídicas aplicables.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">Temporalidad del tratamiento</h2>
          <p className="paragraphs">
            El tratamiento de los Datos Personales se realizará durante el
            término de pertinencia del dato y, en todo caso, hasta el
            cumplimiento de (o las) finalidad(es) para la(s) cual(es) se
            autorizó.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">Uso de Cookies</h2>
          <p className="paragraphs">
            Suprecredito accede a la información en un dispositivo, tales como
            cookies, y procesamos datos personales, tales como identificadores
            únicos e información estándar enviada por un dispositivo, para
            anuncios y contenido personalizados, medición de anuncios y del
            contenido e información sobre el público, así como para desarrollar
            y mejorar productos.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">
            Procedimientos para que los Usuarios de la Información puedan
            ejercer sus Derechos
          </h2>
          <p className="paragraphs">Los derechos de los usuarios son:</p>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Consultas. Las personas Legitimadas podrán consultar la
                información personal en poder de Suprecredito, quien en su
                condición de responsable del tratamiento deberá suministrar la
                información vinculada al Usuario que se encuentre almacenada. La
                consulta se formulará por el medio habilitado por el
                Responsable, siempre y cuando se pueda mantener prueba de la
                fecha de recepción de la consulta y de la identidad del
                solicitante para acreditar su legitimidad y remitir la
                respuesta.
              </p>
              <p className="paragraphs">
                La consulta ​será​ atendida en un término ​máximo​ de diez (10)
                días ​hábiles​ contados a partir de la fecha de recibo de esta.
                Cuando no fuere posible atender la consulta dentro de dicho
                termino, se informará al interesado expresando los motivos de la
                demora y señalando la fecha en que se atenderá́ la consulta, la
                cual en ningún caso podrá́ superar los cinco (5) días hables
                siguientes al vencimiento del primer término.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Reclamos. Las personas Legitimadas podrán pedir la
                actualización, corrección o supresión, o la información personal
                en poder de Suprecredito.
              </p>
              <p className="paragraphs">
                El ​término​ máximo para atender el reclamo será de quince (15)
                días hábiles contados a partir del día siguiente a la fecha de
                su recibo. Cuando no fuere posible atender el reclamo dentro de
                dicho termino, se informará al interesado los motivos de la
                demora y la fecha en que se atenderá́ el reclamo, la cual en
                ningún caso podrá́ superar los ocho (8) días hábiles siguientes
                al vencimiento del primer término.
              </p>
              <p className="paragraphs">
                El reclamo se formulará mediante solicitud dirigida
                a Suprecredito con la identificación del Usuario, la descripción
                de los hechos que dan lugar al reclamo, la dirección física o
                electrónica para remitir la respuesta e informar sobre el estado
                del trámite, y acompañando los documentos o pruebas pertinentes
                que se quieran hacer valer. Si el reclamo resulta incompleto, se
                ​requerirá ́​ al interesado dentro de los cinco (5) días hábiles
                siguientes a su recepción para que subsane las fallas.
                Transcurridos dos (2) meses desde la fecha del requerimiento sin
                que el solicitante presente la información requerida, se
                ​entenderá​ que ha desistido del reclamo.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Las personas ​legitimadas​ sólo podrán elevar queja ante la
                Superintendencia de Industria y Comercio una vez haya agotado el
                trámite de consulta o reclamo ante el Suprecredito como
                responsable del tratamiento.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                En principio, Suprecredito se encargará directamente del
                tratamiento de los Datos Personales. Sin embargo, se reserva el
                derecho a delegar en un tercero, nacional o extranjero, para tal
                tratamiento, exigiéndole el cumplimiento de las disposiciones de
                la presente Política, así como las que deriven del ordenamiento
                jurídico colombiano.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">Ley y Jurisdicción</h2>
          <p className="paragraphs">
            La presente Política se rige por lo previsto en la ley colombiana y
            cualquier controversia relacionada con o derivada de la misma, se
            someterá al conocimiento de la justicia ordinaria de la República de
            Colombia.
          </p>
        </li>
        <li className="paragraphs">
          <h2 className="o-heading-4">Modificaciones</h2>
          <p className="paragraphs">
            Suprecredito se reserva el derecho de modificar, en cualquier
            momento, de manera unilateral la presente Política. Las
            modificaciones serán puestas en conocimiento del Usuario con la
            publicación de estas en el Sitio Web SuprecreditoDigital y entrarán
            en vigor desde el momento de su publicación, a menos que se indique
            algo diferente.
          </p>
          <p className="paragraphs">
            Si las modificaciones requieren del consentimiento expreso del
            Usuario, por modificar las finalidades del tratamiento de sus Datos
            Personales, estos serán informados para que acepte expresamente y
            renueve la Autorización para el tratamiento.
          </p>
          <p className="paragraphs">
            La presente Política para el tratamiento de Datos Personales rige a
            partir de la fecha de su expedición correspondiente al{" "}
            {GeneralData.politictUpdatedAt}.
          </p>
        </li>
      </ol>
    </div>
  );
};
